export const fees = {
  'fees.title': 'الرسوم والخصومات',
  'fees.subtitle': 'بنود الرسوم لكل سنة وصف، والخصومات، والمتأخرات',
  'fees.tabsLabel': 'أقسام الرسوم',
  'fees.tab.items': 'بنود الرسوم',
  'fees.tab.discounts': 'الخصومات',
  'fees.tab.overdue': 'المتأخرات',
  'fees.year': 'السنة الدراسية',
  'fees.yearCurrent': '{name} (الحالية)',
  'fees.items.new': 'بند جديد',
  'fees.items.col.name': 'البند',
  'fees.items.col.grade': 'الصف',
  'fees.items.col.amount': 'المبلغ',
  'fees.items.col.kind': 'النوع',
  'fees.items.col.status': 'الحالة',
  'fees.items.allGrades': 'كل الصفوف',
  'fees.items.mandatory': 'إلزامي',
  'fees.items.optional': 'اختياري',
  'fees.items.active': 'فعّال',
  'fees.items.retired': 'متوقف',
  'fees.items.apply': 'تحميل على الطلاب',
  'fees.items.retire': 'إيقاف',
  'fees.items.reactivate': 'إعادة تفعيل',
  'fees.items.empty': 'لا بنود رسوم لهذه السنة',
  'fees.items.emptyBody': 'أضف القسط الدراسي لكل صف، ثم البنود الاختيارية مثل النقل والكتب.',
  'fees.items.priceNote': 'لا يُعدَّل سعر البند بعد إنشائه لأن الرسوم المحمّلة على الطلاب تحتفظ بنسختها. لتغيير السعر أوقف البند وأنشئ بنداً جديداً.',
  'fees.items.summary': 'الفعّالة: {active}، المتوقفة: {retired}',
  'fees.form.title': 'بند رسوم جديد',
  'fees.form.forYear': 'للسنة الدراسية {name}',
  'fees.form.name': 'اسم البند',
  'fees.form.namePlaceholder': 'مثل: القسط الدراسي، خط النقل',
  'fees.form.amount': 'المبلغ',
  'fees.form.grade': 'الصف',
  'fees.form.optional': 'بند اختياري',
  'fees.form.optionalHint': 'يُحمَّل فقط على طلاب تختارهم (النقل، الزي…). البند الإلزامي يُحمَّل تلقائياً على كل طالب في الصف عند تسجيله.',
  'fees.form.created': 'أُضيف البند',
  'fees.retire.title': 'إيقاف «{name}»؟',
  'fees.retire.body': 'لن يُحمَّل هذا البند على طلاب جدد. الرسوم المحمّلة سابقاً تبقى كما هي.',
  'fees.retire.done': 'أُوقف البند',
  'fees.reactivate.done': 'أُعيد تفعيل البند',
  'fees.apply.title': 'تحميل «{name}»',
  'fees.apply.mandatoryBody': 'سيُحمَّل {amount} على كل طالب مسجّل في {scope} لم يُحمَّل عليه هذا البند بعد. لا يُحمَّل أحد مرتين.',
  'fees.apply.scopeAll': 'كل الصفوف',
  'fees.apply.confirm': 'تحميل الرسوم',
  'fees.apply.result': 'حُمِّل البند على الطلاب، العدد: {n}',
  'fees.apply.none': 'لم يُحمَّل أحد: الطلاب المعنيون لديهم هذا البند مسبقاً',
  'fees.apply.skipped': 'لم يُحمَّل على {n} من المختارين: لديهم البند مسبقاً أو ليسوا في الصف',
  'fees.apply.optionalBody': 'اختر الطلاب الذين يُحمَّل عليهم {amount}.',
  'fees.apply.selected': 'المختارون: {n}',
  'fees.apply.clearSelection': 'إلغاء الاختيار',
  'fees.apply.pickOne': 'اختر طالباً واحداً على الأقل',
  'fees.apply.chargeSelected': 'تحميل على المختارين',
  'fees.apply.gradeOnly': 'تظهر طلاب {grade} فقط.',
  'fees.picker.search': 'ابحث بالاسم أو الرمز أو هاتف ولي الأمر',
  'fees.picker.student': 'الطالب',
  'fees.picker.change': 'تغيير',
  'fees.picker.noClass': 'بلا صف',
  'fees.picker.results': 'نتائج البحث',
  'fees.picker.more': 'يُعرض أول {n}؛ ضيّق البحث لرؤية غيرهم.',
  'fees.discounts.request': 'طلب خصم',
  'fees.discounts.filter': 'حالة الخصم',
  'fees.discounts.col.student': 'الطالب',
  'fees.discounts.col.discount': 'الخصم',
  'fees.discounts.col.appliesTo': 'يشمل',
  'fees.discounts.col.reason': 'السبب',
  'fees.discounts.col.requested': 'تاريخ الطلب',
  'fees.discounts.allFees': 'كل الرسوم',
  'fees.discounts.approve': 'موافقة',
  'fees.discounts.reject': 'رفض',
  'fees.discounts.approved': 'اعتُمد الخصم',
  'fees.discounts.rejected': 'رُفض الخصم',
  'fees.discounts.ownRequest': 'طلبته أنت؛ يقرّره معتمِد آخر',
  'fees.discounts.byYou': 'بطلبك',
  'fees.discounts.emptyPending': 'لا خصومات بانتظار الموافقة',
  'fees.discounts.empty': 'لا خصومات في هذه القائمة',
  'fees.discounts.emptyBody': 'تُطلب الخصومات من صفحة الطالب أو من زر «طلب خصم».',
  'fees.discounts.rule': 'يوافق المدير أو المالك على الخصومات، ولا يوافق أحد على طلبه. الخصم لا يغيّر الرصيد قبل اعتماده.',
  'fees.discounts.rejectTitle': 'رفض خصم {student}؟',
  'fees.discounts.rejectBody': '{discount} — {reason}. لا يمكن التراجع عن الرفض؛ يمكن تقديم طلب جديد.',
  'fees.discountForm.title': 'طلب خصم',
  'fees.discountForm.subtitle': 'يُرسل الطلب للمدير للموافقة، ولا يتغيّر الرصيد قبل اعتماده.',
  'fees.discountForm.kind': 'نوع الخصم',
  'fees.discountForm.percent': 'نسبة مئوية',
  'fees.discountForm.fixed': 'مبلغ ثابت',
  'fees.discountForm.percentValue': 'النسبة (٪)',
  'fees.discountForm.amountValue': 'المبلغ',
  'fees.discountForm.item': 'يشمل',
  'fees.discountForm.allFees': 'كل الرسوم (عدا الرصيد الافتتاحي)',
  'fees.discountForm.reason': 'السبب',
  'fees.discountForm.reasonPlaceholder': 'مثل: خصم أخوة، ابن موظف، منحة دراسية',
  'fees.discountForm.submit': 'إرسال للموافقة',
  'fees.discountForm.sent': 'أُرسل طلب الخصم للموافقة',
  'fees.discountForm.percentMax': 'النسبة لا تتجاوز {max}',
  'fees.discountForm.pickStudent': 'اختر الطالب',
  'fees.overdue.col.student': 'الطالب',
  'fees.overdue.col.overdue': 'المتأخر',
  'fees.overdue.col.balance': 'إجمالي المتبقي',
  'fees.overdue.total': 'المجموع (عدد الطلاب: {n})',
  'fees.overdue.empty': 'لا متأخرات',
  'fees.overdue.emptyBody': 'كل الطلاب ملتزمون بمواعيد أقساطهم.',
  'fees.overdue.hint': 'المتأخر هو ما فات موعده من الأقساط ولم يُدفع؛ تُغطّى الأقساط بالدفعات حسب ترتيبها.',
  'fees.discounts.requestedBy': 'طلبه: {name}',
  'fees.discounts.decidedBy': 'قرّره: {name}',
} as const;
